import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NavItem, NavItemsId, PtEntity } from '@pt/pt-models';
import { NavUtils } from '../../utils';

@Component({
  selector: 'pt-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss']
})
export class ActionBarComponent implements OnChanges {

  @Input() leftAction: NavItem[];
  @Input() rightAction: NavItem[];
  @Input() entity: PtEntity;
  @Input() selectedRows: any[];
  @Input() hideDeleteButton = false; //if true, ngxPermissions directive will be used
  @Input() showDownloadDocumentsButton = false; //if true, ngxPermissions directive will be used
  @Input() navActionMargin = '0px 15px 10px 15px';
  @Output() clickAction = new EventEmitter<NavItem>();

  public rAction: NavItem[] = [];
  public obsoleteAction?: NavItem;

  reloadTable() {
    this.clickAction.emit(NavUtils.buttonReload())
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.rightAction && changes.rightAction.currentValue?.length > 0) {
      this.rAction = [];
      this.obsoleteAction = undefined;
      changes.rightAction.currentValue.forEach((item: NavItem) => {
        if (item.id === NavItemsId.OBSOLETE) {
          this.obsoleteAction = item;
        } else {
          this.rAction.push(item);
        }
      })
    }
  }
}
